import { Button } from '@/ui';

export interface ReflectionBlockActionsProps {
  enabled: boolean;
  onKeep: () => void;
  onUse: () => void;
}

// Sibling controls only; never a measured/selectable Markdown text root.
export const ReflectionBlockActions = ({
  enabled,
  onKeep,
  onUse,
}: ReflectionBlockActionsProps) => (
  <div
    aria-label="Reflection passage actions"
    data-reflection-control="true"
    style={{
      display: 'flex',
      gap: 8,
      justifyContent: 'flex-end',
      margin: '0 0 8px',
      userSelect: 'none',
    }}
  >
    <Button disabled={!enabled} size="small" variant="outlined" onClick={onUse}>
      Use
    </Button>
    <Button
      disabled={!enabled}
      size="small"
      variant="outlined"
      onClick={onKeep}
    >
      Keep
    </Button>
  </div>
);
